<form [formGroup]="tableForm" (ngSubmit)="onSubmit()">
  <fieldset>
    <strong><label for="tableTitle">Nom de la table</label></strong>
    <input type="text" id="tableTitle" formControlName="tableTitle" />
    @if (tableForm.controls.tableTitle.dirty && tableForm.controls.tableTitle.errors) {
      <ul class="error">
        @if (tableForm.controls.tableTitle.errors['required']) {
          <li>La table ne doit pas être vide</li>
        }
        @if (tableForm.controls.tableTitle.errors['tableExists']) {
          <li>{{ tableForm.controls.tableTitle.errors['tableExists'] }}</li>
        }
      </ul>
    }
  </fieldset>
  <fieldset id="tableAttributes" formArrayName="tableAttributes">
    <legend>Attributs de la table</legend>
    <button type="button" (click)="addTableAttributes()" id="addAttribute" class="button-component">Ajouter un attribut</button>

    @for (attribute of attributes.controls; track attribute; let i = $index) {
      <fieldset [formGroupName]="i" class="attribute-field">
        <div>
          <label [for]="'attribute-' + i">Champ</label>
          <button type="button" (click)="removeTableAttribute(i)" aria-label="Supprimer le champ" class="button-component">
            <svg-trash></svg-trash>
            <span class="info">Supprimer le champ</span>
          </button>
        </div>
        <input type="text" [name]="'attribute-' + i" [id]="'attribute-' + i" formControlName="name" appFocus />

        @if (attribute.invalid) {
          <ul class="error">
            @if (attribute.get('attributeName')?.hasError('required')) {
              <li [id]="'li-error-blank-' + i">L'attribut ne doit pas être vide</li>
            }
            @if (attribute.get('attributeName')?.hasError('attributeExists')) {
              <li [id]="'li-error-exists-' + i">{{ attribute.get('attributeName')?.getError('attributeExists') }}</li>
            }
          </ul>
        }
      </fieldset>
    }
  </fieldset>
  <button type="submit" [disabled]="tableForm.invalid" class="button-component">Valider la table</button>
</form>
